import { FC } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Text,
} from '@chakra-ui/react';
import { MenuCategoryEditFormFields } from 'page/MenuCategoryPage/types/menuCategoryEditFormFields';

type Props = {
  values: MenuCategoryEditFormFields;
  handleClose: () => void;
};

export const MenuCategoryEditResultModalView: FC<Props> = ({
  values,
  handleClose,
}) => (
  <ModalContent maxHeight="90vh">
    <ModalHeader p="40px">カテゴリーの更新</ModalHeader>
    <ModalCloseButton />
    <ModalBody overflowY="auto" px="40px">
      <Stack spacing="6" direction="column">
        <FormControl>
          <FormLabel>カテゴリーID</FormLabel>
          <Input
            type="text"
            value={values.id}
            width="240px"
            variant="flushed"
            isReadOnly
            isTruncated
          />
        </FormControl>
        <FormControl>
          <FormLabel>カテゴリー名</FormLabel>
          <Input
            type="text"
            value={values.name}
            variant="flushed"
            isReadOnly
            isTruncated
          />
        </FormControl>
      </Stack>
      <Text align="center" fontWeight="bold" mt="60px">
        更新が完了しました
      </Text>
    </ModalBody>
    <ModalFooter justifyContent="center" mx="20px" gap="16px" p="40px">
      <Button
        w="140px"
        colorScheme="blackAlpha"
        variant="outline"
        onClick={handleClose}
      >
        閉じる
      </Button>
    </ModalFooter>
  </ModalContent>
);
